import React from 'react';

import RichTextEditorPresentation, { Props as PresentationProps } from './Presentation';
import { Theme } from '../../services/events/types';
import { useEventSpaceThemeQuery } from '../../services/theme';
import { Spin } from 'antd';

export * from './Presentation';

export type Props = Omit<PresentationProps, 'linkColor'>;

const RichTextEditor = ({ eventId, ...props }: Props) => {
  const { data: theme, isLoading } = useEventSpaceThemeQuery([eventId]);
  const linkColor = theme?.linkTextColor ?? Theme.defaultLinkTextColor;

  return isLoading ? (
    <Spin />
  ) : (
    <RichTextEditorPresentation {...props} {...{ eventId, linkColor }} />
  );
};

export default RichTextEditor;
